
/**
 * [getCookie Return the content of a given cookie]
 * @param  {String} name [The name of the cookie]
 * @param  {Boolean} json [If true, it will return the cookie has a JSON.parse]
 */
export function getCookie(name, json) {

    // Retrieve the cookie based on the name
    var result = document.cookie.match(new RegExp(name + "=([^;]+)"));

    if (result) {
        // Get the "content" of the cookie
        var cookie = result[1];

        // If JSON, try to convert the cookie content to a javascript object
        if (json) {
            try {
                cookie = JSON.parse(cookie);
            } catch (e) {
                return e;
            }
        }

        return cookie;
    }

    return;
}

/**
 * [setCookie Write a cookie]
 * @param {String} name       [The name of the cookie]
 * @param {Object} value      [The content of the cookie]
 * @param {Object} attributes [A list of optional parameters (path, expires)]
 */
export function setCookie(name, value, attributes = {}) {

    // Check if value is a possible Array or Object, if so pass it has a JSON string
    try {
        var result = JSON.stringify(value);
        if (/^[{[]/.test(result)) {
            value = result;
        }
    } catch (e) {
        // Do nothing
    }

    // Handle the expirations date parameters
    if (typeof attributes.expires === "number") {
        attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
    }
    // We're using "expires" because "max-age" is not supported by IE
    attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";

    // Process all attributes to a formated string
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
            continue;
        }
        stringifiedAttributes += "; " + attributeName;
        if (attributes[attributeName] === true) {
            continue;
        }

        // Considers RFC 6265 section 5.2:
        // ...
        //  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }

    // Construct and save the cookie
    var cookie = name + "=" + value + stringifiedAttributes;

    document.cookie = cookie;
}

/**
 * [removeCookie Remove a given cookie]
 * @param  {String} name   [The name of the cookie]
 * @param  {String} path   [The path of the cookie]
 * @param  {String} domain [The domain of the cookie]
 */
export function removeCookie(name, path, domain) {
    const cookie = getCookie(name);

    if (cookie) {
        document.cookie = name + "=" +
            ((path) ? ";path="+path:"")+
            ((domain)?";domain="+domain:"") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
}
